module.exports = __webpack_public_path__ + "static/media/Workorder API - GBR Network - 24-09-2024.f76d039d.png";